<template>
  <div>
    <div class="z-[1] relative bg-green-300 px-8 pb-24 pt-20 md:px-12 md:pb-32 md:pt-24">
      <div class="mx-auto max-w-5xl">
        <div class="flex flex-col items-start gap-7 text-left md:items-center md:text-center">
          <div class="text-lg font-medium lg:text-xl">{{ t('pages.features.payment.hero.kicker') }}</div>
          <h2 class="text-5xl font-medium md:text-6xl lg:text-7xl xl:text-8xl">{{ t('pages.features.payment.hero.title') }}</h2>
          <div class="max-w-3xl text-lg md:text-2xl lg:leading-10 xl:text-3xl">
            <i18n-t keypath="pages.features.payment.hero.bodyLine1"></i18n-t><br class="hidden override md:inline">
            <span>{{ t('pages.features.payment.hero.bodyLine2') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="relative flex flex-col overflow-hidden border-t border-black lg:flex-row">
      <div class="bg-white flex items-center justify-center border-b order-2 border-black bg-purple p-2 md:p-6 2xl:p-32 xl:p-16 lg:w-1/2 lg:border-b-0 lg:border-r">
        <div class="relative">
          <SmartImage class="h-auto w-full" data-parallax="true" :alt="t('pages.features.payment.hero.imageAlt')" src="/images/features/mobile-app.png" image-style="transform: translateY(0px);" />
        </div>
      </div>
      <div class="z-[1] relative flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
        <div class="text-green-400 max-w-2xl space-y-12 md:space-y-16">
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              {{ t('pages.features.payment.blocks.multiCurrency.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.payment.blocks.multiCurrency.body') }}
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              {{ t('pages.features.payment.blocks.vat.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.payment.blocks.vat.body') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white flex flex-col overflow-hidden border-t border-black lg:flex-row">
      <div class="z-[1] relative flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32 lg:order-2">
        <div class="max-w-2xl space-y-12 md:space-y-16">
          <div class="text-yellow-400 space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              {{ t('pages.features.payment.blocks.simpleApp.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.payment.blocks.simpleApp.body') }}
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              {{ t('pages.features.payment.blocks.basicInfo.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              <i18n-t keypath="pages.features.payment.blocks.basicInfo.body">
                <template #brand>
                  <span class="font-serif">ommi</span>
                </template>
              </i18n-t>
            </p>
          </div>
          <!-- <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              More to come
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              We collect feedback to constantly improve the app. Got some ideas on how to simplify it even more? Let us know.
            </p>
          </div> -->
        </div>
      </div>
      <div class="bg-[#e3cbff] flex items-center justify-center border-b border-black lg:w-1/2 lg:border-b-0 lg:border-r">
        <div class="relative">
          <SmartImage class="h-auto w-full" data-parallax="true" :alt="t('pages.features.payment.blocks.basicInfo.imageAlt')" src="/images/features/app-links.png" image-style="transform: translateY(0px);" />
        </div>
      </div>
    </div>

    <!-- <div class="flex flex-col overflow-hidden border-y border-black lg:flex-row-reverse">
      <div class="flex items-center justify-center border-b border-black bg-purple p-8 py-16 sm:p-12 md:p-16 lg:order-2 lg:w-1/2 lg:border-b-0 lg:border-r xl:p-32">
        <div class="relative max-w-xl">
          <img class="h-auto w-full" data-parallax="true" alt="Illustration showing license keys" src="https://assets.gumroad.com/assets/features/features-5-5a598ac2972885b139498c3fef4e1b552265df806b34054eb5e0e706c51f5a94.svg" style="transform: translateY(0px);">
        </div>
      </div>
      <div class="order-2 flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
        <div class="max-w-2xl space-y-12 md:space-y-16">
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              Generate license keys
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              Selling software? We can create your license keys, so you can get back to beta.
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              Sell multiple versions
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              Allow buyers to pick from PDF, ePub, and Mobi. Even charge more for lossless audio.
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-purple lg:text-4xl xl:text-5xl">
              Protect your work
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              We can create lightweight DRM to help keep customers honest.
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '#imports'
import SmartImage from '~/components/SmartImage.vue'

const { t } = useI18n()
</script>
